import { Box, CircularProgress, Grid, Skeleton } from "@mzc-pdc/ui";
import React from "react";
import theme from "@styles/theme";

const MediaImageWrapper = ({ children, status, variant = "rounded", sx }) => {
    if (status === "IN_PROGRESS") {
        const { width, height, ml, mr, backgroundColor } = sx;
        return (
            <Box
                sx={{
                    width,
                    height,
                    ml,
                    mr,
                    position: "relative",
                    display: "inline-block",
                    backgroundColor: theme.palette.common.white,
                }}
            >
                <Skeleton variant={variant} animation={"wave"} width={width} height={height} sx={{ backgroundColor }} />
                <Box
                    sx={{
                        position: "absolute",
                        left: "0",
                        top: "0",
                        width: "100%",
                        height: "100%",
                    }}
                >
                    {children}
                </Box>
            </Box>
        );
    } else if (status === "IN_UPLOAD") {
        const { width, height } = sx;
        return (
            <Grid
                container
                alignItems={"center"}
                justifyContent={"center"}
                sx={{
                    width,
                    height,
                }}
            >
                <CircularProgress size={width <= 60 ? 16 : 40} color={"inherit"} />
            </Grid>
        );
    }
    return <Box sx={sx}>{children}</Box>;
};

export default MediaImageWrapper;
